<script setup lang="ts">
import { inject, type Ref } from 'vue'
import { useRouter } from 'vue-router'
import { SuiForm, SuiButton, useToast } from 'vue-fomantic-ui'
import { useContainerStore } from '@/stores/containers'
import Title from '@/components/Title.vue'
import ContainerScanHeading from '@/components/Heading/ContainerScanHeading.vue'
import Scanner from '@/components/Scanner/Scanner.vue'

const router = useRouter()
const { toast } = useToast()

const containerStore = useContainerStore()
const containerCodes = inject('containerCodes') as Ref<string[]>

const barcodeScanned = (value: string) => {
  if (containerCodes.value.indexOf(value) > -1) {
    toast({
      position: 'centered',
      message: `Le code barre scanné a déjà été ajouté.`,
      type: 'warning',
    })
    return
  }

  if (containerStore.findByCode(value)) {
    toast({
      position: 'centered',
      message: `Le code barre scanné est déjà utilisé pour un bac.`,
      type: 'warning',
    })
    return
  }

  containerCodes.value.push(value)
}

const removeContainer = (code: string) => {
  containerCodes.value.splice(containerCodes.value.indexOf(code), 1)
}

const next = () => {
  router.push({ name: 'add-container-room' })
}
</script>

<template>
  <div class="page add-container-scan">
    <Title>Ajouter des bacs</Title>
    <SuiForm @submit.prevent="next">
      <ContainerScanHeading></ContainerScanHeading>
      <Scanner class="scanner" target="container" @barcode-scanned="barcodeScanned"></Scanner>
      <div class="containers">
        <div class="container" v-for="code in containerCodes" :key="code">
          <div>{{ code }}</div>
          <button type="button" class="close" @click="removeContainer">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </div>
      <SuiButton class="submit" type="submit" :disabled="containerCodes.length === 0"
        >Continuer</SuiButton
      >
    </SuiForm>
  </div>
</template>

<style scoped lang="scss">
.add-container-scan {
  .ui.form {
    width: 100%;
    padding-bottom: 2dvh;
    text-align: center;

    .containers {
      width: 100%;
      margin: 2.5dvh 0 4dvh;

      .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2dvh 5%;
        font-size: 16px;
        border-top: 1px solid #344c60;

        button {
          padding: 0;
          line-height: 1;
          background: none;
          border: none;

          i.mdi {
            font-size: 24px;
          }
        }
      }
    }
  }
}

/* @TODO: override Fomantic styles in a cleaner way */
.ui.button {
  font-family: 'Libre Franklin', sans-serif;
  padding: 8px 20px 7px 20px;
  background-color: #344c60;
  transition: opacity 0.25s;
  color: white;
  border-radius: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
  height: 40px;
  width: 60%;
  line-height: 22px;
  margin-top: auto;
  margin-bottom: 20px;
}
</style>
